import React, { useEffect, useState } from "react";
import ContentLayout from "../../../../partials/content/ContentLayout";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { DialogActions, Typography } from "@material-ui/core";
import { formatDate } from "../../../../utils/utils";
import { getInquiriesFromEmail } from "../../../../services/crm/inquiryService";
import DialogLayout from "../../../../partials/content/DialogLayout";
import InquiryDetail from "./inquiryDetail";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function Inquiries({ history }) {
  const { reload } = useGlobalData();
  const [emails, setEmails] = useState([]);
  const [inquiryID, setInquiryID] = useState(0);
  const [openInquiryDetail, setOpenInquiryDetail] = useState(false);

  useEffect(() => {
    getInquiriesData();
  }, [reload]);

  return (
    <React.Fragment>
      <PageSubHeader
        title="Inquiry List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/crm/inquiry",
            title: "Inquiries",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
        ]}
      />
      <ContentLayout>
        <div className="row">
          <div className="col-3">
            <Typography align="center">
              <button className="btn btn-icon btn-label-success btn-md btn-circle mx-1">
                1
              </button>
              <br />
              Total
            </Typography>
          </div>
          <div className="col-3">
            <Typography align="center">
              <button className="btn btn-icon btn-label-primary btn-md btn-circle mx-1">
                1
              </button>
              <br />
              New Email
            </Typography>
          </div>
          <div className="col-3">
            <Typography align="center">
              <button className="btn btn-icon btn-label-warning btn-md btn-circle mx-1">
                1
              </button>
              <br />
              Read
            </Typography>
          </div>
          <div className="col-3">
            <Typography align="center">
              <button className="btn btn-icon btn-label-danger btn-md btn-circle mx-1">
                1
              </button>
              <br />
              Overdue
            </Typography>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <CustomDataTable
              data={emails}
              onRefreshData={() => {
                getInquiriesData();
              }}
              onSelectedData={(rowData) => {
                setInquiryID(rowData.ID);
                setOpenInquiryDetail(true);
              }}
              columns={[
                {
                  header: "Email From",
                  field: "emailFrom",
                  body: (rowData) => (
                    <React.Fragment>
                      {rowData.readFlag === "" ? (
                        <strong>
                          <ResponsiveEllipsis
                            text={rowData.emailFrom}
                            maxLine="1"
                          />
                        </strong>
                      ) : (
                        <ResponsiveEllipsis
                          text={rowData.emailFrom}
                          maxLine="1"
                        />
                      )}
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Subject",
                  field: "subject",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis text={rowData.subject} maxLine="1" />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Customer Name",
                  field: "customerName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.customerName}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Received At",
                  field: "CreatedAt",
                  body: (rowData) => (
                    <React.Fragment>
                      {formatDate(rowData.CreatedAt, true)}
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
              ]}
            />
          </div>
        </div>
      </ContentLayout>
      <DialogLayout
        open={openInquiryDetail}
        title="Inquiry Detail"
        maxWIdth="xl"
        onCloseDialog={handleCloseInquiryDetail}
      >
        {inquiryID > 0 ? (
          <InquiryDetail
            inquiryID={inquiryID}
            onReloadInquires={() => {
              handleCloseInquiryDetail();
              getInquiriesData();
            }}
            onCloseDialog={handleCloseInquiryDetail}
          />
        ) : null}

        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseInquiryDetail}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  function handleCloseInquiryDetail() {
    setOpenInquiryDetail(false);
  }

  async function getInquiriesData() {
    const response = await getInquiriesFromEmail();
    const { data } = response.data;
    const { inquiries } = data;
    setEmails(inquiries);
  }
}

export default Inquiries;
